import { useRef, useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../../utils/Utilities.js";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./CreateEmployee.css";
import TopBar from "./TopBar";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ConsignmentBooking = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/GetBookConsignmentByDate");
  }
  // Initialize state for firstTabInput to store form data
  // const [firstTabInput, setFirstTabInput] = useState(""); 
  const [franchiseId, setFranchiseId] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [consignerName, setConsignerName] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [consignerAddress1, setConsignerAddress1] = useState("");
  const [contractDate, setContractDate] = useState("");
  const [consignerAddress2, setConsignerAddress2] = useState("");
  const [consignerPincode, setConsignerPincode] = useState("");
  const [consignerCity, setConsignerCity] = useState("");
  const [consignerMobile, setConsignerMobile] = useState("");
  const [netAmount, setNetAmount] = useState("");
  const [totalGst, setTotalGst] = useState("");
  const [otherCharges, setOtherCharges] = useState("");
  const [ewayBillNos, setEwayBillNos] = useState("");
  const [consigneeMobile, setconsigneeMobile] = useState("");
  const [consignmentType, setconsignmentType] = useState("");
  const [shippingMode, setshippingMode] = useState("");
  const [consigneeName, setconsigneeName] = useState("");
  const [consigneeAddress1, setconsigneeAddress1] = useState("");
  const [consigneeAddress2, setconsigneeAddress2] = useState("");
  const [consigneeCity, setconsigneeCity] = useState("");
  const [pincodeId, setpincodeId] = useState("");
  const [destinationFranchiseId, setdestinationFranchiseId] = useState("");
  const [sector, setsector] = useState("");
  const [goodsName, setgoodsName] = useState("");
  const [goodsValue, setgoodsValue] = useState("");
  const [quantity, setquantity] = useState("");
  const [weight, setweight] = useState("");
  const [amount, setamount] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  const [showValidation2, setShowValidation2] = useState(false);
  const [gst, setgst] = useState("");
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle form completion
  const handleComplete = async () => {
    setIsSubmitting(true);
    const formattedDate = formatDate(bookingDate);
    // Collect form data
    const formData = {
      // franchise_id: franchiseId,
      franchise_id: auth.franchise_id,
      payment_mode: paymentMode,
      consigner_name: consignerName,
      booking_date: formattedDate,
      consigner_address1: consignerAddress1,
      consigner_address2: consignerAddress2,
      consigner_pincode: consignerPincode,
      consigner_city: consignerCity,
      consigner_mobile: consignerMobile,
      net_amount: netAmount,
      total_gst: totalGst,
      consignments: [
        {
          consignee_mobile: consigneeMobile,
          consignment_type: consignmentType,
          shipping_mode: shippingMode,
          consignee_name: consigneeName,
          consignee_address1: consigneeAddress1,
          consignee_address2: consigneeAddress2,
          consignee_city: consigneeCity,
          pincode_id: pincodeId,
          destination_franchise_id: destinationFranchiseId,
          sector: sector,
          goods_name: goodsName,
          quantity: quantity,
          weight: weight,
          amount: amount,
          gst: gst,
          eway_bill_nos: ewayBillNos,
          goods_value: goodsValue,
          other_charges: otherCharges,
        }
      ]
    };

    // console.log("Form Data:", formData); // Log all form data

    try {
      // Format date before sending


      // Prepare payload
      const data = JSON.stringify({
        ...formData,
        // Rename date for backend consistency
      });

      console.log("Payload Data:", data);

      // Make POST request
      const response = await axiosPrivate.post(BOOK_CONSIGNMENT_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true, // Ensure cookies are sent
      });

      console.log("Registration successful:", response.data);

      alert("Registered successfully!"); // Notify the user

      // submitForm(); // Proceed with any additional form submission logic
    } catch (error) {
      console.error("Error submitting form data:", error);
      alert("An error occurred while submitting your data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };



  // Validate first tab input
  const checkValidateTab = () => {
    if (paymentMode === "" || consignerName === "" || bookingDate === "" || consignerAddress1 === "" || consignerAddress2 === "" || consignerPincode === "" || consignerCity === "" || consignerMobile === "" || netAmount === "" || totalGst === "" || otherCharges === "") {
      return false;
    }
    return true; // Both fields are not empty
  };

  // Validate second tab input
  const checkValidateTab2 = () => {
    if (consigneeMobile === "" || consignmentType === "" || shippingMode === "" || consigneeName === "" || consigneeAddress1 === "" || consigneeAddress2 === "" || consigneeCity === "" || pincodeId === "" || destinationFranchiseId === "" || sector === "" || goodsName === "" || goodsValue === "" || quantity === "" || weight === "" || amount === "" || gst === "") {
      return false;
    }
    return true; // Both fields are not empty
  };

  // Error messages for validation
  const errorMessages = () => {
    setShowValidation(true); // Triggers inline messages
    // alert("Please fill in the required fields");
  };

  const errorMessages2 = () => {
    setShowValidation2(true); // Triggers inline messages
    // alert("Please fill in the required fields");
  };

  const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
  const EMAIL_REGEX =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const NAME_REGEX = /^(?!\s*$).+/;
  const BOOK_CONSIGNMENT_URL = "api/book-consignment";

  return (
    <>
      <section className="franchbody">
        <div className="wrapper10">
          <button type="button" className="btn btn-success backbtn" onClick={() => navigate(-1)}>back</button>
          <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">
            Consignment List
          </button>
          <center><h2 className="mul_head">Consignment Booking</h2></center>
          <FormWizard onComplete={handleComplete}>
            <FormWizard.TabContent title="Consigner  Information" icon="ti-user">
              {/* <h3>Consigner  Information</h3> */}
              {/* <p>Some content for the first tab</p> */}

              <div className=" input-boxnew">
                <Row>

                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="paymentMode">Payment </label>

                      <select className="newregselect"
                        name="paymentMode"
                        value={paymentMode}
                        onChange={(e) => setPaymentMode(e.target.value)}
                      >
                        <option value="">Select Mode</option>
                        <option value=" Online">Online</option>
                        <option value=" Cash">Cash</option>
                        {/* <option value="Pan Card">Pan Card</option> */}

                      </select>
                      {showValidation && !paymentMode && (
                        <div className="mt-1 reqstyl"> *Payment Mode is required</div>
                      )}
                    </div>

                  </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="consignerName">Cons. Name </label>

                      <input
                        type="text"
                        className="form-control"
                        value={consignerName}
                        onChange={(e) => setConsignerName(e.target.value)}
                      />
                      {showValidation && !consignerName && (
                        <div className="mt-1 reqstyl"> *Consigner Name is required</div>
                      )}

                    </div>
                  </Col>

                </Row>

                <Row>



                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="bookingDate"> Booking Date  </label>

                      <input
                        type="date"
                        className="form-control"
                        value={bookingDate}
                        onChange={(e) => setBookingDate(e.target.value)}
                        style={{ fontSize: "15px" }}
                      />
                      {showValidation && !bookingDate && (
                        <div className="mt-1 reqstyl"> *Booking Date is required</div>
                      )}

                    </div>
                  </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="consignerAddress1">Cons. Address  </label>


                      <input
                        type="text"
                        className="form-control"
                        value={consignerAddress1}
                        onChange={(e) => setConsignerAddress1(e.target.value)}

                      />
                      {showValidation && !consignerAddress1 && (
                        <div className="mt-1 reqstyl"> *Consigner Address is required</div>
                      )}


                    </div>
                  </Col>
                </Row>

                <Row>

                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="consignerAddress2">Cons. Address2  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={consignerAddress2}
                        onChange={(e) => setConsignerAddress2(e.target.value)}

                      />
                      {showValidation && !consignerAddress2 && (
                        <div className="mt-1 reqstyl"> *Consigner Address is required</div>
                      )}

                    </div>
                  </Col>
                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="consignerPincode">Cons. Pincode  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={consignerPincode}
                        onChange={(e) => setConsignerPincode(e.target.value)}
                      />
                      {showValidation && !consignerPincode && (
                        <div className="mt-1 reqstyl"> *Consigner Pincode is required</div>
                      )}


                    </div>
                  </Col>
                </Row>


                <Row>

                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="consignerCity">Cons. City  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={consignerCity}
                        onChange={(e) => setConsignerCity(e.target.value)}
                      />
                      {showValidation && !consignerCity && (
                        <div className="mt-1 reqstyl"> *Consigner City is required</div>
                      )}


                    </div>
                  </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="consignerMobile">Cons. Mobile  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={consignerMobile}
                        onChange={(e) => setConsignerMobile(e.target.value)}
                      />
                      {showValidation && !consignerMobile && (
                        <div className="mt-1 reqstyl"> *Consigner Mobile is required</div>
                      )}


                    </div>
                  </Col>

                </Row>

                <Row>

                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="netAmount">Net Amount  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={netAmount}
                        onChange={(e) => setNetAmount(e.target.value)}
                      />
                      {showValidation && !netAmount && (
                        <div className="mt-1 reqstyl"> *Net Amount is required</div>
                      )}

                    </div>
                  </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="totalGst">Total Gst</label>


                      <input
                        type="text"
                        className="form-control"
                        value={totalGst}
                        onChange={(e) => setTotalGst(e.target.value)}
                      />
                      {showValidation && !totalGst && (
                        <div className="mt-1 reqstyl"> *GST is required</div>
                      )}


                    </div>
                  </Col>
                </Row>

                <Row>

                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="otherCharges">Other Charges  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={otherCharges}
                        onChange={(e) => setOtherCharges(e.target.value)}
                      />

                      {showValidation && !otherCharges && (
                        <div className="mt-1 reqstyl"> *Other Charges is required</div>
                      )}
                    </div>
                  </Col>
                </Row>



              </div>
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Add Consignment"
              icon="ti-settings"
              isValid={checkValidateTab()} // Validate based on first tab input
              validationError={errorMessages} // Show validation error if invalid
            >
              {/* <h3>Add Consignment</h3> */}



              <Row>

                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="consigneeName">Consignee Name  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={consigneeName}
                      onChange={(e) => setconsigneeName(e.target.value)}
                    />
                    {showValidation2 && !consigneeName && (
                      <div className="mt-1 reqstyl"> *Consignee Name is required</div>
                    )}
                  </div>
                </Col>
                <Col>


                  <div className=" input-boxs">
                    <label htmlFor="consignmentType">Consignment Type  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={consignmentType}
                      onChange={(e) => setconsignmentType(e.target.value)}
                    />
                    {showValidation2 && !consignmentType && (
                      <div className="mt-1 reqstyl"> *Consignment Type is required</div>
                    )}


                  </div>
                </Col>
              </Row>

              <Row><Col>

                <div className=" input-boxs">
                  <label htmlFor="shippingMode">Shipping Mode  </label>

                  <select className="newregselect"
                    name="shippingMode"
                    value={shippingMode}
                    onChange={(e) => setshippingMode(e.target.value)}
                  >
                    <option value="">Select Mode</option>
                    <option value=" Land">Land</option>
                    <option value=" Air">Air</option>
                    <option value=" Sea">Sea</option>

                  </select>
                  {showValidation2 && !shippingMode && (
                    <div className="mt-1 reqstyl"> *Shipping Mode  is required</div>
                  )}

                </div>

              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="consigneeMobile">Consignee Mobile  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={consigneeMobile}
                      onChange={(e) => setconsigneeMobile(e.target.value)}
                    />
                    {showValidation2 && !consigneeMobile && (
                      <div className="mt-1 reqstyl"> *Consignee Mobile  is required</div>
                    )}


                  </div>

                </Col>
              </Row>


              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="consigneeAddress1">Cons. Address1  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={consigneeAddress1}
                    onChange={(e) => setconsigneeAddress1(e.target.value)}
                  />
                  {showValidation2 && !consigneeAddress1 && (
                    <div className="mt-1 reqstyl"> *Consignee Address  is required</div>
                  )}
                </div>
              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="consigneeAddress2">Cons. Address2  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={consigneeAddress2}
                      onChange={(e) => setconsigneeAddress2(e.target.value)}
                    />
                    {showValidation2 && !consigneeAddress2 && (
                      <div className="mt-1 reqstyl"> *Consignee Address  is required</div>
                    )}
                  </div>
                </Col>
              </Row>


              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="consigneeCity">Consignee City  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={consigneeCity}
                    onChange={(e) => setconsigneeCity(e.target.value)}
                  />
                  {showValidation2 && !consigneeCity && (
                    <div className="mt-1 reqstyl"> *Consignee City  is required</div>
                  )}
                </div>
              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="pincodeId">Pincode Id  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={pincodeId}
                      onChange={(e) => setpincodeId(e.target.value)}
                    />
                    {showValidation2 && !pincodeId && (
                      <div className="mt-1 reqstyl"> *PincodeId  is required</div>
                    )}
                  </div>
                </Col>
              </Row>



              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="destinationFranchiseId">Destination Fr_Id  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={destinationFranchiseId}
                    onChange={(e) => setdestinationFranchiseId(e.target.value)}
                  />
                  {showValidation2 && !destinationFranchiseId && (
                    <div className="mt-1 reqstyl"> *Destination Fr_Id  is required</div>
                  )}
                </div>
              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="sector">Sector  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={sector}
                      onChange={(e) => setsector(e.target.value)}
                    />
                    {showValidation2 && !sector && (
                      <div className="mt-1 reqstyl"> *Sector  is required</div>
                    )}
                  </div>
                </Col>
              </Row>

              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="goodsName">Goods Name </label>

                  <input
                    type="text"
                    className="form-control"
                    value={goodsName}
                    onChange={(e) => setgoodsName(e.target.value)}
                  />
                  {showValidation2 && !goodsName && (
                    <div className="mt-1 reqstyl"> *Goods Name  is required</div>
                  )}
                </div>
              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="goodsValue">Goods Value  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={goodsValue}
                      onChange={(e) => setgoodsValue(e.target.value)}
                    />
                    {showValidation2 && !goodsValue && (
                      <div className="mt-1 reqstyl"> *Goods Value  is required</div>
                    )}
                  </div>
                </Col>
              </Row>

              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="quantity">Quantity </label>

                  <input
                    type="text"
                    className="form-control"
                    value={quantity}
                    onChange={(e) => setquantity(e.target.value)}
                  />
                  {showValidation2 && !quantity && (
                    <div className="mt-1 reqstyl"> *Quantity  is required</div>
                  )}
                </div>
              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="weight">Weight  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={weight}
                      onChange={(e) => setweight(e.target.value)}
                    />
                    {showValidation2 && !weight && (
                      <div className="mt-1 reqstyl"> *Weight  is required</div>
                    )}
                  </div>
                </Col>
              </Row>


              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="amount">Amount </label>

                  <input
                    type="text"
                    className="form-control"
                    value={amount}
                    onChange={(e) => setamount(e.target.value)}
                  />
                  {showValidation2 && !amount && (
                    <div className="mt-1 reqstyl"> *Amount  is required</div>
                  )}
                </div>
              </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="gst">Gst  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={gst}
                      onChange={(e) => setgst(e.target.value)}
                    />
                    {showValidation2 && !gst && (
                      <div className="mt-1 reqstyl"> *GST  is required</div>
                    )}
                  </div>
                </Col>
              </Row>


              <Row>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="otherCharges">Other Charges  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={otherCharges}
                      onChange={(e) => setOtherCharges(e.target.value)}
                    />
                    {showValidation2 && !otherCharges && (
                      <div className="mt-1 reqstyl"> *Other Charges  is required</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="ewayBillNos">Eway BillNos  </label>
                    <input
                      type="text"
                      className="form-control"
                      value={ewayBillNos}
                      onChange={(e) => setEwayBillNos(e.target.value)}
                    />
                    {showValidation2 && !ewayBillNos && (
                      <div className="mt-1 reqstyl"> *Eway BillNos  is required</div>
                    )}
                  </div>
                </Col>

              </Row>


            </FormWizard.TabContent>



            <FormWizard.TabContent title="Last step" icon="ti-check"
              isValid={checkValidateTab2()} // Validate based on first tab input
              validationError={errorMessages2} // Show validation error if invalid
            >
              <h3>Review Details</h3>
              {/* <p>Here is a summary of your details:</p> */}

              <Row>
                <Col><p className="multip"><span className="empspan">Franchise Id :</span> {franchiseId}</p> </Col>
                <Col><p className="multip"><span className="empspan">Payment Mode :</span> {paymentMode}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Consigner Name :</span> {consignerName}</p></Col>
                <Col><p className="multip"><span className="empspan">Booking Date :</span> {bookingDate}</p> </Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Consigner Address 1 :</span> {consignerAddress1}</p></Col>
                <Col><p className="multip"><span className="empspan">Consigner Address 2 :</span> {consignerAddress2}</p> </Col>


              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Consigner Pincode :</span> {consignerPincode}</p></Col>
                <Col><p className="multip"><span className="empspan">Consigner City :</span> {consignerCity}</p></Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Consigner Mobile :</span> {consignerMobile}</p></Col>
                <Col><p className="multip"><span className="empspan">Net Amount  :</span> {netAmount}</p></Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Total Gst :</span> {totalGst}</p></Col>
                <Col><p className="multip"><span className="empspan">Other Charges :</span> {otherCharges}</p></Col>

              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Eway BillNos :</span> {ewayBillNos}</p></Col>
                <Col></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Consignee Mobile :</span> {consigneeMobile}</p></Col>
                <Col><p className="multip"><span className="empspan">Consignment Type :</span> {consignmentType}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Shipping Mode :</span> {shippingMode}</p></Col>
                <Col><p className="multip"><span className="empspan">ConsigneeName :</span> {consigneeName}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Consignee Address1 :</span> {consigneeAddress1}</p></Col>
                <Col><p className="multip"><span className="empspan">Consignee Address2 :</span> {consigneeAddress2}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Consignee City :</span> {consigneeCity}</p></Col>
                <Col><p className="multip"><span className="empspan">Pincode Id :</span> {pincodeId}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Destination FranchiseId :</span> {destinationFranchiseId}</p></Col>
                <Col><p className="multip"><span className="empspan">Sector :</span> {sector}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Goods Name :</span> {goodsName}</p></Col>
                <Col><p className="multip"><span className="empspan">Goods Value :</span> {goodsValue}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Quantity :</span> {quantity}</p></Col>
                <Col><p className="multip"><span className="empspan">Weight :</span> {weight}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Amount :</span> {amount}</p></Col>
                <Col><p className="multip"><span className="empspan">GST :</span> {gst}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Other Charges :</span> {otherCharges}</p></Col>
                <Col><p className="multip"><span className="empspan">Eway BillNos :</span> {ewayBillNos}</p></Col>


              </Row>


            </FormWizard.TabContent>
          </FormWizard>

        </div>
      </section>
      <TopBar />
    </>
  );
};

export default ConsignmentBooking;
